module.exports = __webpack_public_path__ + "img/file-icon_png.b0a401d0.svg";